export default __webpack_public_path__ + "static/media/guardian_color.2d991e8c.png";